function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from 'react';
import { Controls, validators } from 'shared/helper/form';
var Select = Controls.Select;
var notEmpty = validators.notEmpty;
var LocalizationPreferences = function LocalizationPreferences(_ref) {
  var allowFilterUpdates = _ref.allowFilterUpdates,
    countries = _ref.countries,
    currencies = _ref.currencies,
    currencySelectionDisabled = _ref.currencySelectionDisabled,
    currentLocalization = _ref.currentLocalization,
    fields = _ref.fields,
    languages = _ref.languages,
    localizations = _ref.localizations,
    methods = _ref.methods,
    siteLanguage = _ref.siteLanguage,
    styles = _ref.styles,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? 'Country' : _ref$label,
    placeholder = _ref.placeholder,
    _ref$validators = _ref.validators,
    validators = _ref$validators === void 0 ? {
      notEmpty: notEmpty
    } : _ref$validators;
  var _useState = useState(countries),
    _useState2 = _slicedToArray(_useState, 2),
    filteredCountries = _useState2[0],
    setFilteredCountries = _useState2[1];
  var _useState3 = useState(languages),
    _useState4 = _slicedToArray(_useState3, 2),
    filteredLanguages = _useState4[0],
    setFilteredLanguages = _useState4[1];
  var _useState5 = useState(currencies),
    _useState6 = _slicedToArray(_useState5, 2),
    filteredCurrencies = _useState6[0],
    setFilteredCurrencies = _useState6[1];
  var _methods$watch = methods.watch(['country']),
    _methods$watch2 = _slicedToArray(_methods$watch, 1),
    country = _methods$watch2[0];
  var filterCurrenciesAndLanguages = function filterCurrenciesAndLanguages(_ref2) {
    var availableLanguages = _ref2.availableLanguages,
      availableCurrencies = _ref2.availableCurrencies;
    var filteredCurrencies = allowFilterUpdates && availableCurrencies.length > 0 ? currencies.filter(function (currency) {
      return availableCurrencies.indexOf(currency.value) !== -1;
    }) : currencies;
    setFilteredCurrencies(filteredCurrencies);
    var filteredLanguages = allowFilterUpdates && availableLanguages.length > 0 ? languages.filter(function (language) {
      return availableLanguages.indexOf(language.isoCode) !== -1;
    }) : languages;
    setFilteredLanguages(filteredLanguages);
  };
  useEffect(function () {
    methods.setValue('currency', filteredCurrencies.length === 1 ? filteredCurrencies[0] : {
      value: null
    });
  }, [filteredCurrencies.length]);
  useEffect(function () {
    methods.setValue('language', filteredLanguages.length > 0 ? {
      label: filteredLanguages[0].name,
      value: filteredLanguages[0].isoCode
    } : {
      value: null
    });
  }, [filteredLanguages.length]);
  useEffect(function () {
    var isoCode = currentLocalization.isoCode;
    if (countries.length === 0) {
      return;
    }
    if (isoCode) {
      var availableCountry = countries.find(function (country) {
        return country.isoCode === isoCode;
      });
      setFilteredCountries([availableCountry]);
      methods.setValue('country', availableCountry);
    } else {
      setFilteredCountries(countries);
    }
    filterCurrenciesAndLanguages(currentLocalization);
  }, [countries.length, currentLocalization && currentLocalization.isoCode]);
  useEffect(function () {
    var selectedCountry = methods.getValues('country');
    if (!selectedCountry) {
      return;
    }
    var matchingLocalization = localizations.find(function (localization) {
      return localization.isoCode === selectedCountry.isoCode;
    });
    filterCurrenciesAndLanguages(matchingLocalization || {
      availableCurrencies: [],
      availableLanguages: []
    });
  }, [country && country.value]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, fields.country ? /*#__PURE__*/React.createElement("div", {
    className: filteredCountries.length === 1 ? 'd-none' : 'd-block'
  }, /*#__PURE__*/React.createElement(Select, {
    label: label,
    placeholder: placeholder,
    messages: {
      notEmpty: "Value is required and can't be empty"
    },
    name: "country",
    validators: validators,
    options: filteredCountries.map(function (country) {
      return {
        enforcesDataProtection: country.enforcesDataProtection,
        isoCode: country.isoCode,
        label: country.label,
        value: country.value
      };
    }),
    sort: true,
    styles: styles
  })) : null, fields.language ? /*#__PURE__*/React.createElement("div", {
    className: filteredLanguages.length === 1 ? 'd-none' : 'd-block'
  }, /*#__PURE__*/React.createElement(Select, {
    label: "registration-form-language",
    messages: {
      notEmpty: "Value is required and can't be empty"
    },
    name: "language",
    validators: {
      notEmpty: notEmpty
    },
    defaultValue: {
      value: siteLanguage
    },
    options: filteredLanguages.map(function (language) {
      return {
        label: language.name,
        value: language.isoCode
      };
    }),
    styles: styles
  })) : null, fields.currency && !currencySelectionDisabled ? /*#__PURE__*/React.createElement("div", {
    className: filteredCurrencies.length <= 1 ? 'd-none' : 'd-block'
  }, /*#__PURE__*/React.createElement(Select, {
    readOnly: currencySelectionDisabled,
    label: "Currency",
    messages: {
      notEmpty: "Value is required and can't be empty"
    },
    name: "currency",
    validators: {
      notEmpty: notEmpty
    },
    styles: styles,
    description: "Customer currency description",
    options: filteredCurrencies.map(function (currency) {
      return {
        label: currency.label,
        value: currency.value
      };
    })
  })) : null);
};
export default LocalizationPreferences;